import React from 'react';
import { ArrowRight } from 'lucide-react';
import { RoofEmblem } from './RoofEmblem';
const QUOTE_URL = 'https://www.myquickroofquote.com/contractors/texas-direct-roofing-&-construction';
interface QuoteCardProps {
  className?: string;
  compact?: boolean;
}
export function QuoteCard({
  className = '',
  compact = false
}: QuoteCardProps) {
  return <a href={QUOTE_URL} target="_blank" rel="noopener noreferrer" className={`group block bg-white rounded-2xl shadow-xl overflow-hidden transition-shadow duration-300 hover:shadow-2xl ${className}`} data-id="element-209">
      <div className="flex flex-col sm:flex-row" data-id="element-210">
        {/* Accent bar: top on mobile, left on desktop */}
        <div className="h-2 w-full sm:h-auto sm:w-2 bg-tx-red shrink-0" data-id="element-211" />

        <div className={`flex items-start gap-4 ${compact ? 'p-5' : 'p-6 sm:p-8'}`} data-id="element-212">
          <div className="bg-tx-light rounded-xl p-2.5 shrink-0" data-id="element-213">
            <RoofEmblem className={compact ? 'w-9 h-9' : 'w-11 h-11'} data-id="element-214" />
          </div>

          <div className="flex-1 min-w-0" data-id="element-215">
            <h3 className={`font-heading font-extrabold text-tx-navy tracking-tight leading-tight ${compact ? 'text-lg' : 'text-xl sm:text-2xl'}`} data-id="element-216">
              Free Roof Quote in 60 Seconds
            </h3>
            <p className={`text-gray-600 mt-1.5 leading-relaxed ${compact ? 'text-sm' : 'text-sm sm:text-base'}`} data-id="element-217">
              Answer a few quick questions and get your estimate. No phone call
              required.
            </p>

            <span className="mt-4 inline-flex w-full items-center justify-center gap-2 bg-tx-red group-hover:bg-tx-red/90 text-white font-bold rounded-lg min-h-12 px-6 transition-colors" data-id="element-218">
              Start My Free Quote
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-219" />
            </span>
          </div>
        </div>
      </div>
    </a>;
}